import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const APIKEY_GOOGLE_MAPS = environment.apiKeyGoogleMaps;

// Función para crear el elemento script que carga la API de Google Maps
(function loadGoogleMaps() {    
  // Evitar doble carga
  if ((window as any).google?.maps || document.getElementById('gmaps-sdk')) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${APIKEY_GOOGLE_MAPS}&loading=async&libraries=marker`;
  script.async = true;   
  script.defer = true;

  document.body.appendChild(script);
})();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
